import React, { useState } from "react";
import { Box, CssBaseline, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile

    // Retrieve user data from localStorage
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const userRole = userData?.role;

    const isSidebarVisible = userRole !== "user" || userData.is_company_admin === "1";

    const [mobileOpen, setMobileOpen] = useState(isSidebarVisible);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };



    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "#F1F5F9" }}>
            <CssBaseline />

            {/* Fixed Topbar - Hide menu button if userRole is "user" */}
            <Topbar handleDrawerToggle={handleDrawerToggle} />

            {/* Sidebar - Show for superadmin, admin, and company_admin users */}
            {isSidebarVisible && (
                <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
            )}


            {/* Main Content - Hide when sidebar is open on mobile */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 2,
                    marginLeft: !isMobile && mobileOpen && isSidebarVisible ? "260px" : "0px",
                    display: isMobile && mobileOpen ? "none" : "block",
                    // marginLeft: !isMobile && mobileOpen && userRole !== "user" ? "260px" : "0px", // Shift content only if sidebar is visible
                    // display: isMobile && mobileOpen ? "none" : "block", // Hide content when sidebar is open on mobile
                    transition: "margin-left 0.3s ease-in-out",
                    overflowY: "auto",
                    height: "calc(100vh - 90px)",
                    mt: 8,
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default Layout;
